import i18next from 'i18next';
// TODO: lookup dinamici da DB (machine_states, device_types, ecc.) restano fuori da questo
// client — arrivano già tradotti dal backend (?lang= sugli endpoint) e non passano per i18next.
// Questo client gestisce solo le risorse statiche (testi UI) passate in config.resources.
export async function initI18n(config) {
    const resources = Object.fromEntries(Object.entries(config.resources ?? {}).map(([locale, translation]) => [locale, { translation }]));
    await i18next.init({
        lng: config.defaultLocale,
        fallbackLng: config.fallbackLocale,
        interpolation: { escapeValue: false },
        resources,
    });
    return i18next;
}
export { i18next };
//# sourceMappingURL=client.js.map